/* LUSH Stories – Story-Artikel: veredelt den Artikel-Inhalt (gleiches Schema für alle Artikel) */
(function () {
  var root = document.querySelector('[data-article-story]');
  if (!root) return;
  var body = root.querySelector('[data-as-body]');
  if (!body) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('as-js');

  var txt = function (el) { return (el.textContent || '').replace(/ /g, ' ').trim(); };
  var isEmpty = function (el) { return !txt(el) && !el.querySelector('img, video, iframe, svg'); };

  /* ---------- Footer-Welle ---------- */
  function markLast() {
    var f = document.querySelector('[class*="shopify-section-group-footer-group"] .footer__container') || document.querySelector('[class*="shopify-section-group-footer-group"] footer');
    if (f) {
      var bg = getComputedStyle(f).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') document.documentElement.style.setProperty('--as-footer', bg);
    }
    var sec = root.closest('.shopify-section');
    if (!sec || !sec.parentElement) return;
    var sibs = Array.prototype.filter.call(sec.parentElement.children, function (e) {
      return e.classList.contains('shopify-section') && e.offsetHeight > 0;
    });
    sibs.forEach(function (e) { e.classList.remove('as-last'); });
    var lastSec = sibs[sibs.length - 1];
    if (lastSec && lastSec !== sec) lastSec.classList.add('as-last');
  }
  markLast();
  window.addEventListener('load', markLast);

  /* ---------- 0. Inline-Formatierungen alter Artikel entfernen (einheitliche Grössen) ---------- */
  Array.prototype.slice.call(body.querySelectorAll('[style]')).forEach(function (el) {
    ['font-size', 'font-family', 'line-height', 'text-align', 'letter-spacing', 'text-transform'].forEach(function (p) { el.style.removeProperty(p); });
    if (!(el.getAttribute('style') || '').trim()) el.removeAttribute('style');
  });
  Array.prototype.slice.call(body.querySelectorAll('font, [align]')).forEach(function (el) {
    el.removeAttribute('size'); el.removeAttribute('face'); el.removeAttribute('align');
  });

  /* ---------- 1. Aufräumen ---------- */
  Array.prototype.slice.call(body.children).forEach(function (el) {
    if (/^(P|H1|H2|H3|H4|H5|H6|DIV)$/.test(el.tagName) && isEmpty(el)) el.remove();
    else if (el.tagName === 'BR') el.remove();
  });

  var blocks = Array.prototype.slice.call(body.children);

  /* ---------- 2. Bild-Absätze → Medienblöcke ---------- */
  blocks.forEach(function (el) {
    var img = el.tagName === 'IMG' ? el : el.querySelector('img');
    if (img && !txt(el)) {
      el.classList.add('as-media', 'as-reveal');
      if (el.tagName !== 'IMG' && !el.classList.contains('as-media--pair')) {
        var w = img.naturalWidth || parseInt(img.getAttribute('width') || '0', 10);
        if (w === 0 || w >= 1400) el.classList.add('as-media--wide');
      }
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    }
  });
  Array.prototype.slice.call(body.querySelectorAll('.as-figure')).forEach(function (f) { f.classList.add('as-reveal'); });

  /* ---------- 3. Lead ---------- */
  var first = body.firstElementChild;
  if (first && /^(H3|H4|H5|H6)$/.test(first.tagName) && txt(first).length > 60) first.classList.add('as-lead');

  /* ---------- 4. Autorenzeile ---------- */
  blocks.forEach(function (el) {
    if (el.tagName === 'P' && /^(verfasst von|geschrieben von|text:|rédigé par|écrit par|scritto da|redatto da)/i.test(txt(el))) el.classList.add('as-byline');
  });

  /* ---------- 5. Zitate ---------- */
  Array.prototype.slice.call(body.querySelectorAll('blockquote')).forEach(function (bq) {
    bq.classList.add('as-reveal');
    var next = bq.nextElementSibling;
    if (next && next.tagName === 'P' && /^[–—-]/.test(txt(next)) && txt(next).length < 160) {
      next.classList.add('as-cite');
      bq.appendChild(next);
    }
  });
  Array.prototype.slice.call(body.children).forEach(function (el) {
    if (el.tagName !== 'P' || el.closest('blockquote')) return;
    var t = txt(el);
    var strong = el.querySelector('strong, b');
    if (/^[„“"«»]/.test(t) && /[“”"»«]$/.test(t) && strong && txt(strong).length > t.length * 0.7) {
      el.classList.add('as-quote', 'as-reveal');
    }
  });

  /* ---------- 6. Abschluss-CTA ---------- */
  var last = body.lastElementChild;
  if (last && !body.querySelector('.as-cta') && /^(H3|H4|H5)$/.test(last.tagName) && !last.classList.contains('as-lead')) {
    var links = Array.prototype.slice.call(body.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]'));
    var target = last.querySelector('a[href]');
    if (!target && links.length) {
      var counts = {};
      links.forEach(function (a) { var h = a.getAttribute('href'); counts[h] = (counts[h] || 0) + 1; });
      var best = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
      target = { href: best, label: null };
    }
    if (target) {
      var href = target.getAttribute ? target.getAttribute('href') : target.href;
      var cta = document.createElement('div');
      cta.className = 'as-cta as-reveal';
      var h = document.createElement('p');
      h.innerHTML = last.innerHTML;
      Array.prototype.slice.call(h.querySelectorAll('a')).forEach(function (a) { a.replaceWith(document.createTextNode(a.textContent)); });
      var btn = document.createElement('a');
      btn.className = 'as-cta__btn';
      btn.href = href;
      btn.innerHTML = '<span></span><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.firstChild.textContent = root.getAttribute('data-t-cta');
      var pin2 = root.getAttribute('data-pin2');
      if (pin2) {
        var pw = document.createElement('div');
        pw.className = 'as-cta__pin';
        pw.setAttribute('aria-hidden', 'true');
        var pi = document.createElement('img');
        pi.src = pin2; pi.alt = ''; pi.loading = 'lazy'; pi.width = 160; pi.height = 160;
        pw.appendChild(pi);
        cta.appendChild(pw);
      }
      cta.appendChild(h);
      cta.appendChild(btn);
      last.replaceWith(cta);
    }
  }

  /* ---------- 7. Kapitel-Pills ---------- */
  var heads = Array.prototype.slice.call(body.querySelectorAll('h2')).filter(function (h) { return txt(h); });
  var toc = root.querySelector('[data-as-toc]');
  var list = root.querySelector('[data-as-toc-list]');
  var slug = function (s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'kapitel';
  };
  var tocLinks = [];
  heads.forEach(function (h) { if (!h.id) h.id = slug(txt(h)); });
  if (toc && list && heads.length >= 2) {
    var used = {};
    heads.forEach(function (h) {
      h.classList.add('as-reveal');
      var id = h.id;
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = txt(h).replace(/[?:]$/, '');
      li.appendChild(a);
      list.appendChild(li);
      tocLinks.push(a);
    });
    toc.hidden = false;

    tocLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        t.classList.add('is-in');
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });
  }
  if (location.hash) {
    var jump = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (jump) {
      jump.classList.add('is-in');
      setTimeout(function () { jump.scrollIntoView({ block: 'start' }); }, 80);
    }
  }

  /* ---------- 8. Lesefortschritt + Nach-oben ---------- */
  var bar = document.querySelector('.as-progress span');
  var topBtn = root.querySelector('[data-as-top]');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (topBtn) topBtn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.2);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (topBtn) topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

  /* ---------- 9. Einblenden beim Scrollen ---------- */
  var reveals = Array.prototype.slice.call(root.querySelectorAll('.as-reveal'));
  if (hasIO && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- 10. Bild-Zoom ---------- */
  var dlg = root.querySelector('[data-as-lightbox]');
  var dlgImg = root.querySelector('[data-as-lightbox-img]');
  if (dlg && dlgImg && typeof dlg.showModal === 'function') {
    body.addEventListener('click', function (e) {
      var img = e.target.closest('.as-media img');
      if (!img || img.closest('a')) return;
      var src = img.currentSrc || img.src;
      dlgImg.src = src.replace(/([?&])width=[0-9]+/, '$1width=2400');
      dlgImg.alt = img.alt || '';
      dlg.showModal();
    });
    var close = function () { dlg.close(); };
    root.querySelector('[data-as-lightbox-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  /* ---------- Personen: Weiterlesen ---------- */
  Array.prototype.slice.call(root.querySelectorAll('[data-as-more]')).forEach(function (btn) {
    var box = btn.closest('.as-person');
    var textBox = box.querySelector('.as-person__text');
    if (textBox && textBox.scrollHeight <= textBox.clientHeight + 4) { btn.hidden = true; box.classList.add('is-open'); return; }
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
  });

  /* ---------- 11. Link kopieren ---------- */
  var toast = document.createElement('div');
  toast.className = 'as-toast';
  toast.setAttribute('role', 'status');
  document.body.appendChild(toast);
  var showToast = function (msg) {
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2000);
  };
  Array.prototype.slice.call(root.querySelectorAll('[data-as-copy]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-as-copy');
      var done = function () {
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
        showToast(root.getAttribute('data-t-copied'));
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
      else {
        var ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        ta.remove();
      }
    });
  });
})();
